import React, {Component} from 'react';
import '../memberList/MemberList.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import {Label} from "reactstrap";
import moment from "moment/moment";

class MemberBirthDays extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading: false,
        };

        this.cancelProcess = this.cancelProcess.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
    }


    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    renderBirthDays() {
        return (
            <div className="page-content">
                <div className="row">
                    {
                        ((this.props.currentUser.realm !== null)) && this.props.birthdays.map(member => {
                            return (
                                <div className="col-12">
                                    <div className="row">
                                        <Label className="col-sm-6" style={{
                                            color: "black",
                                            fontWeight: "bold"
                                        }}>{member.ad + " " + member.soyad + " (" + member.odaSicilNo + ")"}</Label>
                                        <Label className="col-sm-6" style={{
                                            color: "cornflowerblue",
                                            fontWeight: "bold"
                                        }}>{moment(member.dogumTarihi).format("DD-MM-YYYY")}</Label>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }


    render() {
        return (
            <div>
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                {this.renderBirthDays()}
            </div>
        )
    }
}

export default MemberBirthDays;


// WEBPACK FOOTER //
// ./src/page/home/MemberBirthDays.js